<div class="flex flex-col items-center justify-center max-md:p-2.5 max-md:mt-[90px] gap-4">
  <h1 class="font-bold max-md:text-6xl text-8xl flex flex-wrap max-md:flex-nowrap font-tektur gap-2.5 max-md:gap-0 relative
             portrait:xl:flex-nowrap portrait:xl:w-[75%] portrait:max-md:w-full portrait:max-xl:flex-nowrap portrait:max-xl:w-[75%]
             landscape:max-lg:flex-nowrap landscape:max-lg:w-[82%]" i18n>
    CARS GIVE FREEDOM
    <img ngSrc="assets/images/ukraine-flag.svg" class="max-md:absolute bottom-[14%] right-[10%]" height="26" width="47" alt="Ukraine Flag">
  </h1>
  <div class="h3" i18n>
    We source, upgrade and deliver cars to the frontlines in Ukraine.
  </div>
</div>

<div class="flex gap-4 max-md:flex-col max-md:p-2.5 max-md:w-full cursor-pointer">
  <app-main-donate-button class="min-w-[340px] hidden lg:block"
                          [eventParams]="{ trackEvent: 'Donate_header', section: 'header' }"/>
  <app-main-donate-button class="min-w-[340px] lg:hidden"
                          href="#quick-donation"
                          target="_self"
                          [useDonorBox]="false"
                          [eventParams]="{ trackEvent: 'Donate_header', section: 'header' }"/>
  <app-donate-car-button class="min-w-[340px]" [eventParams]="{ trackEvent: 'Donate_car_header', section: 'header' }"/>
</div>
